module.exports = __webpack_public_path__ + "static/img/s501.42ca7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s501.png
// module id = 563
// module chunks = 3